import './style.css';

const style = {
  main: 'p-10 flex flex items-center py-32 relative pb-28',
  name: 'font-light text-xl md:text-4xl gruppo',
  desc: 'flex flex-col items-center justify-center w-[60%]',
  image: 'relative w-[40%] flex md:items-center md:justify-center mb-auto z-10',
  img: 'rounded-full md:h-[250px] md:w-[250px]',
  content: '',
  img_container: 'mt-10 md:mt-0 shadow-xl p-2 bg-[#dfe0e6] rounded-full',
};

export default style;
